var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03Pinterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.8,0C1.7,0,0,1.7,0,3.8c0,1.6,1,2.9,2.4,3.5c0-0.3-0.1-0.8,0-1.1c0.1-0.3,0.4-1.9,0.4-1.9S2.7,4.1,2.7,3.7 c0-0.5,0.3-0.9,0.7-0.9c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.8-0.3,1.2C3.5,5,3.8,5.3,4.1,5.3c0.7,0,1.2-0.7,1.2-1.7 C5.3,2.7,4.7,2,3.7,2C2.7,2,2,2.8,2,3.7C2,4,2.2,4.3,2.3,4.5c0,0,0,0.1,0,0.1c0,0.1-0.1,0.4-0.1,0.4c0,0.1-0.1,0.1-0.1,0 C1.6,4.9,1.4,4.2,1.4,3.7c0-1.2,0.9-2.3,2.5-2.3c1.3,0,2.3,0.9,2.3,2.2c0,1.3-0.8,2.3-1.9,2.3c-0.4,0-0.7-0.2-0.9-0.4 c0,0-0.2,0.7-0.2,0.9C3,6.7,2.8,7.1,2.6,7.3C3,7.4,3.4,7.5,3.8,7.5c2.1,0,3.7-1.7,3.7-3.7S5.8,0,3.8,0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Pinterest);
export default __webpack_public_path__ + "static/media/03-pinterest.de053cdeffa20f6d8ccefd383171a801.svg";
export { ForwardRef as ReactComponent };